var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "SaveView",
      class: {
        "SaveView--fixed": _vm.fixed,
        "SaveView--gray": _vm.gray,
        visible: _vm.show,
        saved: _vm.saved,
      },
    },
    [
      _vm.fixed
        ? _c("div", [
            _c("div", { staticClass: "SaveViewButtons" }, [
              _c("div", { staticClass: "SaveViewButtons-box" }, [
                _c(
                  "button",
                  {
                    staticClass: "SaveViewSave",
                    attrs: { disabled: _vm.saving },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.$emit("save")
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.saving,
                            expression: "!saving",
                          },
                        ],
                      },
                      [_vm._v("Сохранить изменения")]
                    ),
                    _vm._v(" "),
                    _c("vue-loading", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.saving,
                          expression: "saving",
                        },
                      ],
                      staticClass: "SaveViewLoader",
                      attrs: {
                        type: "spin",
                        color: "white",
                        size: { width: "30px", height: "30px" },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "SaveViewCancel",
                    attrs: { disabled: _vm.saving },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.checkCancel()
                      },
                    },
                  },
                  [_c("span", [_vm._v("Не сохранять")])]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "SaveViewSaved" }, [
              _vm._v(
                "\n\t\t\tYour changes have been saved, and are now live on the site.\n\t\t"
              ),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }